/**
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@shoelace-style/shoelace/dist/components/button/button.js';
let ChromedashWPTEvalButton = class ChromedashWPTEvalButton extends LitElement {
    constructor() {
        super(...arguments);
        this.featureId = 0;
    }
    static { this.styles = css `
    :host {
      display: inline-block;
    }

    .gemini-icon {
      width: 1.5em;
      height: 1.5em;
      transform-origin: center center;
      transition: transform 0.7s ease-in-out;
    }

    sl-button:hover .gemini-icon {
      transform: rotate(360deg);
    }
  `; }
    render() {
        return html `
      <sl-button href="/feature/${this.featureId}/ai-coverage-analysis">
        <img
          slot="prefix"
          class="gemini-icon"
          src="https://www.gstatic.com/images/branding/productlogos/gemini_2025/v1/192px.svg"
          alt="Gemini AI Logo"
        />
        Analyze test coverage
      </sl-button>
    `;
    }
};
__decorate([
    property({ type: Number })
], ChromedashWPTEvalButton.prototype, "featureId", void 0);
ChromedashWPTEvalButton = __decorate([
    customElement('chromedash-wpt-eval-button')
], ChromedashWPTEvalButton);
export { ChromedashWPTEvalButton };
